import type { ReactNode } from 'react';

interface ParentStatProps {
  /** Polish caption naming the figure, e.g. `Termin`. */
  label: string;
  children: ReactNode;
}

/**
 * One labelled figure in a parent card or detail dialog.
 *
 * The parent views line several of these up on one row — dates, status,
 * attempts — and a parent reads a row by scanning the captions, so the
 * caption/value pairing has to look identical in every one of them.
 * `ParentGradeValue` and `QAttemptResultCard` come with their own captions
 * already, so they stay as they are; this is for everything else.
 */
export function ParentStat(parentStatProps: ParentStatProps) {
  const { label, children } = parentStatProps;

  return (
    <div className={'space-y-0.5'}>
      <p className={'text-muted-foreground text-xs'}>{label}</p>
      <div className={'text-foreground text-xs font-medium'}>{children}</div>
    </div>
  );
}
